import { useState } from 'react';
import * as ReactHelmetAsync from 'react-helmet-async';
const Helmet = ReactHelmetAsync.Helmet || (ReactHelmetAsync as any).default?.Helmet;
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { PageHero } from '@/components/sections/PageHero';
import { useHomeData } from '@/hooks/useHomeData';

export function FAQ() {
  const { homeData } = useHomeData();
  const [openItems, setOpenItems] = useState<number[]>([]);

  const toggleItem = (index: number) => {
    setOpenItems(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  return (
    <>
      <Helmet>
        <title>Frequently Asked Questions | Total Tailwheel</title>
        <meta
          name="description"
          content="Common questions about tailwheel endorsement training, flight school costs, aircraft rental, and training requirements at Total Tailwheel in Massachusetts."
        />
        <meta name="keywords" content="tailwheel training FAQ, tailwheel endorsement questions, flight school FAQ Massachusetts, Cessna 170 training questions" />
        <meta property="og:title" content="Frequently Asked Questions | Total Tailwheel" />
        <meta property="og:description" content="Get answers to common questions about our tailwheel training programs, pricing, and requirements." />
        <link rel="canonical" href="https://totaltailwheel.com/faq" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Navigation />
        
        <PageHero title="FAQ" />

        {/* FAQ Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-3xl font-medium text-primary text-center mb-8">
                {homeData.faq.title}
              </h2>
              <div className="space-y-4">
                {homeData.faq.questions.map((faq, index) => (
                  <div key={index} className="bg-white rounded-lg shadow-sm border border-secondary/20 overflow-hidden">
                    <button
                      onClick={() => toggleItem(index)}
                      className="w-full p-6 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                    >
                      <h3 className="text-lg font-medium text-primary pr-4">{faq.question}</h3>
                      {openItems.includes(index) ? (
                        <ChevronUp className="text-primary flex-shrink-0" size={20} />
                      ) : (
                        <ChevronDown className="text-primary flex-shrink-0" size={20} />
                      )}
                    </button>
                    {openItems.includes(index) && (
                      <div className="px-6 pb-6">
                        <p className="text-foreground/80 leading-relaxed">{faq.answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}